export default "__VITE_ASSET__fb0f4181__"